//src/assets/scripts/about.js

import PageJS from './dining/page';
import CommonJS from './common';
const common = new CommonJS();
const page = new PageJS(common);
page.init();